import { Link } from '@/components/Elements/Link/Link';
import styles from './link-button.module.scss';
import clsx from 'clsx';

type LinkButtonProps = {
  text: string;
  className?: string;
  onClick: () => void;
};

export const LinkButton = ({ text, className, onClick }: LinkButtonProps) => {
  return (
    <div className={clsx(className, styles.linkButton)}>
      <Link className={styles.link} text={text} onClick={onClick} />
    </div>
  );
};
